import type {
  ChainedBlockchainLocation,
  TransferLocation,
} from '@shared/graphql'

/**
 * Type guard to check if a given transfer location is a chained location.
 */
export function isChainedBlockchainLocation(
  location: TransferLocation | undefined,
): location is ChainedBlockchainLocation {
  return (
    location != null &&
    ('isCompleteAceTransfer' in location || 'metadata' in location)
  )
}
